<template>
  <LazyDrawer position="right" :is-open="specificationsTray" :hide-scroll="false">
    <template #header>
      <Stack tag="div" align="start" justify="end">
        <button @click="closeTray()" class="text-charcoal-default justify-self-end">
          <Icon name="plus-thick" filled class="text-charcoal-default rotate-45" :size="16" />
        </button>
      </Stack>

      <Heading tag="h3" size="xs" class="mt-xs">Specifications</Heading>
    </template>

    <aside class="pt-md px-sm">
      <Stack direction="col" gap="sm">
        <Stack
          v-for="(section, index) in specificationsDataFields"
          :key="index"
          align="center"
          justify="between"
          class="w-full py-[12px] border-b-sm border-grey-light"
          gap="xs"
        >
          <Text>{{ capitalizeFirstLetter(section.name) }}</Text>
          <Text size="sm" weight="bold" data-test-id="specificationsTrayValue">{{ section.value }}</Text>
        </Stack>
      </Stack>
    </aside>
  </LazyDrawer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import useUIState from "~/composables/useUIState";

interface SpecificationField {
  name: string;
  value: string;
}

const data = defineProps<{ specificationFields: SpecificationField[] }>();
const { setSpecificationsTray, specificationsTray } = useUIState();

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const closeTray = () => {
  setSpecificationsTray();
};

const specificationsDataFields = computed(() => {
  const initialData = data.specificationFields || [];
  return initialData.length > 0
    ? initialData
        .filter((field: SpecificationField) => !field.name.includes("file_") && !field.name.includes("icon"))
        .map(({ name, value }: SpecificationField) => {
          return {
            name: name.replace("_", " "),
            value: value,
          };
        })
    : [];
});
</script>
